import axios from "../../utils/axios";

export const postSave = async ({ id, isSaved }) => {
  const response = await axios.patch(`/blogs/${id}`, {
    isSaved: !isSaved,
  });

  return response.data.isSaved;
};
